import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../hooks/use-services.hook";
import {PlaneHorizontalFilledIcon} from "../../../assets/svg/plane-horizontal-filled.icon";

const LineBox: React.FC = observer(() => {
    const services = useServices();
    const styles: CSSProperties = {
        flexGrow: 1,
        height: '1px',
        backgroundColor: services.theme.currentTheme.border.mainColor
    };

    return (
        <div style={styles}/>
    )

})

export const HorizontalPlaneBox: React.FC = observer(() => {
    const services = useServices();
    const styles: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
        justifyContent: 'center',
        width: '100%',
        gap: services.theme.currentTheme.spacing.flexGap12
    };

    return (
        <div style={styles}>
            <LineBox/>
            <PlaneHorizontalFilledIcon size={1.6}/>
            <LineBox/>
        </div>

    )
})